export default __webpack_public_path__ + "static/media/MLove.81ff7c7f.svg";